import React, { useMemo } from 'react'
import { Flag } from 'react-bootstrap-icons'
import { MapContainer, Popup, TileLayer, GeoJSON, Circle } from 'react-leaflet'
import EChartsReact from 'echarts-for-react';
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { observer } from 'mobx-react-lite';

export default observer(function Countries({ currentAuthentication }) {
  const country = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.country, [currentAuthentication?.audience_information?.detailed_audience_stats?.country])
  const city = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.city, [currentAuthentication?.audience_information?.detailed_audience_stats?.city])

  const countryNames = useMemo(() => country?.map(({ name, country_code }) => {
    const truncatedName = name.length > 10 ? name.substring(0, 8) + '...' : name
    return `${getUnicodeFlagIcon(country_code)} ${truncatedName}`
  }), [country])

  const option = useMemo(() => ({
    xAxis: {
      data: countryNames && [...countryNames] || [],
      axisLabel: {
        interval: 0,
        align: 'center',
        padding: [0, 0, 0, 10],
        margin: 16
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
    },
    yAxis: {
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    series: [
      {
        type: 'bar',
        data: country?.map(({ percentage }) => ({
          value: +(percentage * 100).toFixed(2),
          label: { show: true, position: 'top', formatter: '{c}%' }
        })),
        itemStyle: {
          barBorderRadius: [10, 10, 0, 0],
          borderWidth: 1,
          borderType: 'solid',
          borderColor: '#2CCDB4',
          color: '#2CCDB4'
        },
        label: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      }
    ],
    grid: {
      left: 20,
      right: 20,
      top: 30,
      bottom: 80,
      containLabel: true
    },
    textStyle: {
      fontSize: 14
    }
  }), [countryNames, country])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-4">
      <div className="w-1/4 mb-4 flex items-center p-4">
        <div className="text-gray-400 dark:text-gray-500 mr-2">
          <Flag />
        </div>
        <p className="font-bold text-xl dark:text-white">Audience Countries</p>
      </div>
      <div>
        <MapContainer center={[47, 8]} zoom={5} scrollWheelZoom={false} style={{ height: 500, width: '100%', zIndex: 0 }}>
          <TileLayer
            attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
            url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
          />
          {country?.map(({ name, polygon, percentage }) => (
            <GeoJSON key={name} data={polygon} style={{ fillColor: '#2CCDB4', color: '#2CCDB4' }} >
              <Popup>{name}: {(percentage * 100).toFixed(2)}%</Popup>
            </GeoJSON>
          ))}
          {city?.map(({ name, lng, lat, percentage }) => (
            <Circle
              key={name}
              center={[lat, lng]}
              pathOptions={{
                color: '#183e59',
                fillColor: '#66afe9',
                fillOpacity: 0.5
              }}
              radius={300000 * percentage} >
              <Popup>{name}: {(percentage * 100).toFixed(2)}%</Popup>
            </Circle>
          ))}
        </MapContainer>
      </div>
      <div className="p-4">
        <EChartsReact option={option} style={{ width: '100%', height: '300px' }} />
      </div>
    </div>
  )
})
